import Popover from 'bootstrap/js/src/popover';

export const gobletPopover = () => {
    const tmrGobletPopover = setInterval(() => {
        let popovers = document.querySelectorAll('[data-js-popover]');
        if (popovers.length > 0) {
            clearInterval(tmrGobletPopover)
            popovers.forEach((el, ind) => {
                return new Popover(el, {
                    trigger: 'hover',
                    placement: 'bottom',
                    customClass: 'goblet-popover'
                });
            })
        }
    }, 200);
}

export const tariffPopover = () => {
    const tmrTariffPopover = setInterval(() => {
        let internetSpeedPopover = document.querySelectorAll('[js-popover-internet-speed], [js-popover-tv-rec]');
        if (internetSpeedPopover.length > 0) {
            clearInterval(tmrTariffPopover)
            internetSpeedPopover.forEach((el, ind) => {
                return new Popover(el, {
                    trigger: 'hover',
                    placement: 'top',
                    customClass: 'internet-speed-popover'
                });
            })
        }
    }, 200);
}

export const aboutPopover = () => {
    const guaranteedPaymentInput = document.querySelector('input[name="guaranteed-payment"]');
    const guaranteedPaymentValue = guaranteedPaymentInput ? guaranteedPaymentInput.value : '';
    const tmrAboutPopover = setInterval(() => {
        let guaranteedPayment = document.querySelector('.guaranteed-payment');
        if (guaranteedPayment) {
            clearInterval(tmrAboutPopover);
            return new Popover(guaranteedPayment, {
                trigger: 'hover',
                placement: 'left',
                customClass: 'guaranteed-payment__popover',
                content: guaranteedPaymentValue
            });
        }
    }, 200);
}


export default class Popovers {
    constructor() {
        this.eventListeners()
    }

    eventListeners() {
        const tmrPopovers = setInterval(() => {
            if (document.readyState !== 'loading') {
                let popovers = document.querySelectorAll('[data-js-popover]');
                if (popovers.length > 0) {
                    popovers.forEach((el, ind) => {
                        return new Popover(el, {
                            trigger: 'hover',
                            placement: 'bottom',
                            customClass: 'goblet-popover'
                        });
                    })
                }

                let internetSpeedPopover = document.querySelectorAll('[js-popover-internet-speed], [js-popover-tv-rec]');
                if (internetSpeedPopover.length > 0) {
                    internetSpeedPopover.forEach((el, ind) => {
                        return new Popover(el, {
                            trigger: 'hover',
                            placement: 'top',
                            customClass: 'internet-speed-popover'
                        });
                    })
                }

                let guaranteedPayment = document.querySelectorAll('.guaranteed-payment');
                if (guaranteedPayment.length > 0) {
                    guaranteedPayment.forEach((el, ind) => {
                        return new Popover(el, {
                            trigger: 'hover',
                            placement: 'left',
                            customClass: 'guaranteed-payment__popover',
                            content: 'На посуточной тарификации списывается 12 рублей единоразово, все дополнительные услуги ' +
                                'включаются и работают при отрицательном балансе 3-ое суток, в течение которых необходимо погасить минус. ' +
                                'На помесячной тарификации сразу же списывается фиксированная сумма, размер которой зависит от подключенных ' +
                                'услуг и тарифа Клиента (в том числе аренда оборудования). В течение 3-ех дней, пока действует услуга, ' +
                                'необходимо погасить задолженность (при её наличии), а также внести на счёт сумму, равную стоимости тарифа ' +
                                'и всех дополнительных услуг для их продления. Сумма рассчитана и зафиксирована для каждого тарифа и набора ' +
                                'подключенных услуг Клиента. Сумма рассчитывается как 12 рублей плюс 10% (3 дня из 30 в месяц) от стоимости ' +
                                'ежемесячного платежа за все подключенные Клиенту услуги.'
                        });
                    })
                }

                clearInterval(tmrPopovers)
            }
        }, 200);
    }
}
